export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '类型',
      dataIndex: 'name',
      width: 100,
      render: 'typeRender',
    },
    {
      title: 'ID',
      dataIndex: 'itemId',
      width: 100,
    },
    {
      title: '名称',
      dataIndex: 'itemName',
      width: 300,
    },
    {
      title: '工艺及材料说明',
      dataIndex: 'description',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '适用产品',
      dataIndex: 'applyProdName',
      width: 200,
    },
    {
      title: '适用门店',
      dataIndex: 'orgName',
      width: 100,
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 100,
      itemType: 'date',
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 100,
      itemType: 'date',
    },
    {
      title: '操作',
      width: 120,
      render: 'optionCell',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'keyword',
      label: '通项或者产品名称',
    },
    {
      name: 'itemId',
      label: 'ID',
    },
    { label: '适用产品', name: 'applyProdId', itemType: 'custom', render: 'searchSelectRender' },
    {
      label: '适用门店',
      name: 'orgId',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
    },
  ],
  footer: [
    { label: '下载导入模板', render: 'downloadRender' },
    { label: '批量导入', render: 'importRender' },
    { label: '导出', render: 'exportRender' },
    { label: '新增', type: 'primary', events: ['onClick:onAdd'] },
  ],
  batchActions: [],
}
